import { render, staticRenderFns } from "./MInplayDetail.vue?vue&type=template&id=ef285682&scoped=true"
import script from "./MInplayDetail.vue?vue&type=script&lang=js"
export * from "./MInplayDetail.vue?vue&type=script&lang=js"
import style0 from "./MInplayDetail.vue?vue&type=style&index=0&id=ef285682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef285682",
  null
  
)

export default component.exports